<script lang="ts">
    import { get } from "svelte/store";
    import type { Collection, Material } from "../gateway/models";
    import { flinkGateway, requests, setupSharedProps, sharedProps } from "../services";
    import ProgressBar from "./ProgressBar.svelte";
    import { Asset } from "@lernetz/svelte-image";

    export let model:Material;
    export let collection:Collection;

    let cover = get(model).cover
    let imgUrl:string = undefined;

    setupSharedProps();

    if(cover != undefined) {
        imgUrl = sharedProps.flinkUrl + "/assets/convert/" + $cover.file + "/focusOffsetX=" + $cover.focus.x + "&focusOffsetY=" + $cover.focus.y + "/card-300.webp";
    }

    console.log(get(model))
    console.log(imgUrl)

    function getMaterialUrl() {

      return collection.link + '/' + $model.publicId;
    }

</script>

<div>
  <a href="{getMaterialUrl()}" class="h-[300px] rounded-2xl flex flex-col transition-all duration-200 shadow-md hover:-translate-y-4 hover:shadow-2xl overflow-hidden relative bg-light-grey" target="_blank">
    <ProgressBar progress="{$model.progress}" backgroundColor={"light-grey"} class="absolute bottom-16 left-16 right-16" />

    <div class="relative w-full aspect-[20/13] overflow-hidden" style:background-color={$model.color}>
      {#if cover != undefined}
          <img src={imgUrl} alt=""/>
      {/if}
    </div>
    <div class="h-8" style:background-color={$model.color}></div>
    <div class="p-16 min-h-[150px]">
        <span class="text-almost-black text-14 font-bold text-ellipsis overflow-hidden">{$model.title}</span>
    </div>
  </a>

</div>

